// extracted by mini-css-extract-plugin
module.exports = {"card":"CookieBanner_card__Pdn2w","heading":"CookieBanner_heading__RzB_7","buttons":"CookieBanner_buttons__F1aBl","button":"CookieBanner_button__6H6of"};